import { render, staticRenderFns } from "./setores-funcao.vue?vue&type=template&id=1277608c&"
import script from "./setores-funcao.vue?vue&type=script&lang=js&"
export * from "./setores-funcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports